import { useContext } from 'react';
import { USER_ROLES, UserContext } from '@namespace/user';
import {
  useGetIsRecentlyPlayedLoaded,
  useGetIsRecommendedGamesLoaded
} from '../../store';

export const useIsScrollToPrevPositionEnabled = ({
  isScrollToPrevPositionEnabledInitial,
  showRecentlyPlayedCategory,
  showRecommendedCategory,
  suggesterServiceEntityName
}: {
  isScrollToPrevPositionEnabledInitial: boolean;
  showRecommendedCategory?: boolean;
  showRecentlyPlayedCategory?: boolean;
  suggesterServiceEntityName: string;
}) => {
  const [user] = useContext(UserContext);
  const { role } = user;
  const IS_USER = role === USER_ROLES.USER;
  const isRecommendedGamesLoaded = useGetIsRecommendedGamesLoaded(
    suggesterServiceEntityName
  );

  const isRecentlyPlayedLoaded = useGetIsRecentlyPlayedLoaded(
    suggesterServiceEntityName
  );

  if (IS_USER) {
    const meetsRecommendedCondition =
      !showRecommendedCategory ||
      (showRecommendedCategory && isRecommendedGamesLoaded);

    const meetsRecentlyPlayedCondition =
      !showRecentlyPlayedCategory ||
      (showRecentlyPlayedCategory && isRecentlyPlayedLoaded);

    return (
      isScrollToPrevPositionEnabledInitial &&
      meetsRecommendedCondition &&
      meetsRecentlyPlayedCondition
    );
  }
  return isScrollToPrevPositionEnabledInitial;
};
